import * as React from 'react';

import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { commitDiagramModel } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { updateMappingUniqueKeySets } from 'src/containers/ProjectDiagram/utils/mapping/updateMappingUniqueKeySets';

export const useUpdateMappingUniqueKeySets = (key?: string) => {
  const diagram = useDiagram();

  return React.useCallback(
    (uniqueKeySets: string[]) => {
      if (!diagram || !key) {
        return;
      }
      commitDiagramModel(
        diagram,
        updateMappingUniqueKeySets({
          key,
          uniqueKeySets,
        })
      );
    },
    [diagram, key]
  );
};
